/* eslint-disable @typescript-eslint/camelcase */
import React, { useState } from 'react';
 
import PaymentMethod from './modules/PaymentMethod';
 
import { SocketProvider } from 'src/hooks/Socket';
 

const PaymentMethodContainer: React.FC = () => {
 

  return (
   
      <SocketProvider>
        <PaymentMethod

        />
     </SocketProvider>
  );
};
export default PaymentMethodContainer;
